import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import Introduct from '../components/introduct/introduct'
import DirectorGeneral from '../components/introduct/directorGeneral'
import NewMessage from '../components/newMessage/newMessage'
import Events from '../components/newMessage/events'
import Activity from '../components/newMessage/activity'
import Article from '../components/newMessage/article'
import Enrolls from '../components/huiye/index'
import Download from '../components/huiye/download'
import HuiyeRule from '../components/huiye/huiyeRule'
import HuiYeSuccess from '../components/huiye/success'
import Titbits from '../components/titbits/index'
import AllTitbits from '../components/titbits/allTitbits'
import MobileAlbum from '../components/titbits/mobileAlbum'
import ActivityRules from '../components/activity/index'
import OnlineEnroll from '../components/activity/onlineEnroll'
import Works from '../components/activity/works'
import Work from '../components/activity/worksDetail'
import VoteSuccess from '../components/activity/success'
import MyEcononmicOutlook from '../components/mediaCenter/myEconomicOutlook'
import News from '../components/mediaCenter/news'
import DirectorLogs from '../components/mediaCenter/directorLogs'
import Report from '../components/mediaCenter/report'
import ContactUs from '../components/mediaCenter/contactUs'
import AnArticle from '../components/mediaCenter/Anarticle'
import Match from '../components/commonSense/commonSense'
import Commonsense from '../components/commonSense/index'
import NameList from '../components/commonSense/nameList'
import AllQuestion from '../components/commonSense/allQuestion'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index
    },
    {
      path: '/introduct',
      name: 'introduct',
      component: Introduct
    },
    {
      path: '/director-general',
      name: 'director-general',
      component: DirectorGeneral
    },
    {
      path: '/new-message',
      name: 'new-message',
      component: NewMessage
    },
    {
      path: '/events',
      name: 'events',
      component: Events
    },
    {
      path: '/activity',
      name: 'activity',
      component: Activity
    },
    {
      path: '/article',
      name: 'article',
      component: Article
    },
    {
      path: '/enrolls',
      name: 'enrolls',
      component: Enrolls
    },
    {
      path: '/download',
      name: 'download',
      component: Download
    },
    {
      path: '/huiye-rule',
      name: 'huiye-rule',
      component: HuiyeRule
    },
    {
      path: '/huiye-success',
      name: 'huiye-success',
      component: HuiYeSuccess
    },
    {
      path: '/titbits',
      name: 'titbits',
      component: Titbits
    },
    {
      path: '/all-titbits',
      name: 'all-titbits',
      component: AllTitbits
    },
    {
      path: '/mobile-album',
      name: 'mobile-album',
      component: MobileAlbum
    },
    {
      path: '/activity-rules',
      name: 'activity-rules',
      component: ActivityRules
    },
    {
      path: '/online-enroll',
      name: 'online-enroll',
      component: OnlineEnroll
    },
    {
      path: '/activity-works',
      name: 'activity-works',
      component: Works
    },
    {
      path: '/activity-work',
      name: 'activity-work',
      component: Work
    },
    {
      path: '/vote-success',
      name: 'vote-success',
      component: VoteSuccess
    },
    {
      path: '/media-center',
      name: 'media-center',
      component: MyEcononmicOutlook
    },
    {
      path: '/news',
      name: 'news',
      component: News
    },
    {
      path: '/report',
      name: 'report',
      component: Report
    },
    {
      path: '/director-logs',
      name: 'director-logs',
      component: DirectorLogs
    },
    {
      path: '/contact-us',
      name: 'contact-us',
      component: ContactUs
    },
    {
      path: '/an-article',
      name: 'an-article',
      component: AnArticle
    },
    {
      path: '/common-sense',
      name: 'common-sense',
      component: Commonsense
    },
    {
      path: '/match',
      name: 'match',
      component: Match
    },
    {
      path: '/name-list',
      name: 'name-list',
      component: NameList
    },
    {
      path: '/all-question',
      name: 'all-question',
      component: AllQuestion
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js